import { useCurrentAccountId } from '../../redux/selector';
import { VENDORLINK_PREFIX_PATH } from '../../configs/AppConfig';

export const useAccountPrefixPath = () => {
  const accountId = useCurrentAccountId()!;
  if (!accountId) {
    return VENDORLINK_PREFIX_PATH;
  }
  return accountPrefixPath(accountId);
};

export const accountPrefixPath = (accountId: number) => {
  return `${VENDORLINK_PREFIX_PATH}/${accountId}`;
};
